import React from "react";
import {CardContent, CardHeader, Grid, Tab, Tabs, Button, Stack} from "@mui/material";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {ToolbarCard} from "../../../../../Components/Cards/ToolbarCard";
import {useSelector, useDispatch} from "react-redux";
import {setModal} from "../../../../Common/App";
import {DeleteThemeModal} from "../Modals/DeleteThemeModal";

export const Toolbar = ({ tab, setTab, onClone, onActivate }) => {

    const selectedTheme = useSelector((store) => store.themes.selected);
    const dispatch = useDispatch();
    
    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    const handleClone = () => {
        if (selectedTheme && selectedTheme.id) {
            onClone(selectedTheme);
        }
    };

    const handleActivate = () => {
        if (selectedTheme && selectedTheme.id) {
            onActivate(selectedTheme);
        }
    };


    const handleDelete = () => {
        if (selectedTheme && selectedTheme.id) {
            dispatch(setModal({
                component: <DeleteThemeModal theme={selectedTheme} />,
                open: true
            }));
        }
    };

    return (
        <Grid container spacing={3} sx={{mb:3}}>
            <Grid item xs={12}>
                <ToolbarCard>
                    <CardHeader
                        avatar={<AppRegistrationIcon color="secondary" fontSize="large" />}
                        title="Themes"
                        subheader="Themes Details"
                            action={
                                <Stack direction="row" spacing={2}>
                                    <Button disabled={Boolean(true)} variant="outlined" color="primary" onClick={() => setTab(1)}>
                                        Add New
                                    </Button>
                                    
                                    <Button 
                                        disabled={!selectedTheme || !selectedTheme.id || selectedTheme?.is_active} 
                                        variant="contained" 
                                        color="success" 
                                        startIcon={<PlayArrowIcon />}
                                        onClick={handleActivate}
                                    >
                                        {selectedTheme?.is_active ? "Active" : "Activate Theme"}
                                    </Button>
                                    <Button 
                                        disabled={!selectedTheme || !selectedTheme.id} 
                                        variant="outlined" 
                                        color="secondary" 
                                        startIcon={<ContentCopyIcon />}
                                        onClick={handleClone}
                                    >
                                        Clone
                                    </Button>
                                    <Button 
                                        disabled={!selectedTheme || !selectedTheme.id || selectedTheme?.is_active} 
                                        variant="outlined" 
                                        color="error" 
                                        startIcon={<DeleteIcon />}
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </Button>
                                </Stack>
                            }
                    />
                    <CardContent>
                        <Tabs value={tab} onChange={handleTabChange}>
                            <Tab label="Preview" value={0} />
                        </Tabs>
                    </CardContent>
                </ToolbarCard>
            </Grid>
        </Grid>
    )
}